import {updateFactory} from '@modifi/redux'
import {
  getAuthenticatedThemisClient,
  ExistingFinancialDataSetView,
} from '@modifi/onboarding-api-clients'

import {selectFinancialDataSet, aFetchFinancialDataSet} from '../../../data/financial-data-set'
import {aFetchInputFields} from '../../../data/input-fields'

const apiClient = getAuthenticatedThemisClient()

const getExternalFinancialDataSetId = (
  financialDataSet: ExistingFinancialDataSetView[],
  year: string,
  docType: string
): string =>
  financialDataSet.find(dataSet => {
    const dateTo = new Date(dataSet.dateTo!)
    const yearTo = dateTo?.getFullYear()
    return yearTo?.toString() === year && dataSet?.documentType === docType
  })?.externalId || ''

const {actions, selectors, reducer} = updateFactory({
  rootSelector: state => state?.pages?.yearlyClosingGroup,
  actionNamePrefix: 'pages/yearly-closing-group/root',
  submitRequest:
    (a, changes) =>
    async (dispatch, getState): Promise<void> => {
      dispatch(a.pendingAction())
      const financialDataSet = selectFinancialDataSet(getState())
      type DocBodyType = {
        fileId: string
        externalFinancialDataSetId: string
      }
      const added = [] as DocBodyType[]
      const removed = [] as DocBodyType[]
      Object.keys(changes)?.forEach(changesKey => {
        if (changesKey.includes('upload')) {
          // document changes
          // if docs are added
          if (changes.upload.added.length > 0) {
            changes.upload.added.forEach((addedDoc: {fileId: string; documentType: string}) => {
              const docsParts = addedDoc?.documentType?.split('--')
              const externalFinancialDataSetId = getExternalFinancialDataSetId(
                financialDataSet,
                docsParts[1],
                docsParts[0]
              )
              added.push({externalFinancialDataSetId, fileId: addedDoc.fileId})
            })
          }
          if (changes.upload.removed.length > 0) {
            changes.upload.removed.forEach((removedFileId: string) => {
              const externalFinancialDataSetId =
                financialDataSet.find(dataSet =>
                  // @ts-expect-error to be fixed once BE is ready
                  dataSet.files.find(file => file.fileId === removedFileId)
                )?.externalId || ''
              removed.push({externalFinancialDataSetId, fileId: removedFileId})
            })
          }
        }
      })

      try {
        if (added?.length > 0 || removed?.length > 0) {
          await Promise.all([
            ...added.map(file =>
              apiClient.CompanyFinancials.linkDocument({
                externalFinancialDataSetId: file.externalFinancialDataSetId,
                body: {
                  fileId: file.fileId,
                },
              })
            ),
            ...removed.map(file =>
              apiClient.CompanyFinancials.unlinkDocument({
                externalFinancialDataSetId: file.externalFinancialDataSetId,
                fileId: file.fileId,
              })
            ),
          ])
        }
      } catch (e: any) {
        dispatch(a.errorAction(e))
        return
      }
      await dispatch(aFetchFinancialDataSet())
      dispatch(a.successAction())
      dispatch(aFetchInputFields())
    },
})

export default reducer

export const {
  selectUpdatePending: selectSavePending,

  selectUpdateErrorMessage: selectSaveErrorMessage,
} = selectors

export const {aSubmit} = actions
